import { api } from '@/lib/trpc/react';
import { skipToken } from '@tanstack/react-query';
import { useRouter } from 'next/router';

export const useIsSharedChat = () => {
  const router = useRouter();

  const isSharedChat = router.pathname.startsWith('/s');

  const shareId = router.query.id as string | undefined;

  const { data, isLoading } = api.share.sharedChatbot.useQuery(
    shareId ?? skipToken,
    {
      enabled: !!shareId,
    },
  );

  return {
    isSharedChat,
    shareId: isSharedChat ? (shareId ?? null) : null,
    shareData: data,
    isLoading,
  };
};
